import { baseApi } from "../baseApi";

export const pricelistApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPriceList: builder.query({
      query: (params) => ({
        url: `/api/resource/Price List`,
        params
      }),
    }),
  }),
});

export const { useGetPriceListQuery } = pricelistApi;
